/* LYLAC — lightweight motion engine.
   Framer-Motion-style scroll reveals + subtle parallax, no framework/library needed.
   Respects prefers-reduced-motion. Safe to include once, site-wide. */
(function(){
  if (window.__lylacMotion) return;
  window.__lylacMotion = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(){
    var els = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el){
      if (!el.style.getPropertyValue('--reveal-delay')) {
        var group = el.closest('[data-reveal-group]');
        if (group) {
          var siblings = Array.prototype.slice.call(group.querySelectorAll('[data-reveal]'));
          var idx = siblings.indexOf(el);
          el.style.setProperty('--reveal-delay', Math.min(idx * 80, 480) + 'ms');
        }
      }
      io.observe(el);
    });
  }

  function initParallax(){
    if (reduceMotion) return;
    var hosts = document.querySelectorAll('[data-parallax]');
    if (!hosts.length) return;

    var ticking = false;

    function update(){
      var vh = window.innerHeight;
      hosts.forEach(function(host){
        var rect = host.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var target = host.querySelector('[data-parallax-target]') || host.querySelector('img');
        if (!target) return;
        var offset = rect.top * 0.1;
        target.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function(){
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot(){
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-scan after theme editor / ajax section loads so reveals still fire.
  document.addEventListener('shopify:section:load', initReveal);
  document.addEventListener('cart:refresh', initReveal);
})();
